import React from 'react';
import ZonePoliciesTable from './zone-policies-table';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export function ZonePoliciesMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '20px 10px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <ZonePoliciesTable />
    </div>
  );
}
